import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Login from '../pages/Login'
import MainFrame from '../pages/MainFrame'
import Index from '../pages/Index/Index'
import CenterIntroduce from '../pages/CenterIntroduce/Index'
import JudgmentCase from '../pages/JudgmentCase/List'
import MediateDisputes from '../pages/MediateDisputes/List'
import News from '../pages/News/List'
import ProceedingService from '../pages/ProceedingService/List'
import MediatorList from '../pages/Mediator/Mediator'
import CaseList from '../pages/CaseQuery/CaseList'
import CaseRecord from '../pages/CaseQuery/CaseQueryRecord'
import Manager from '../pages/SysManagement/Manager'
import Complaint from '../pages/SysManagement/Complaint'

const router = new VueRouter({
    routes: [{
        path: "/",
        redirect: "/login"
    }, {
        path: "/login",
        component: Login
    }, {
        path: "/sys",
        component: MainFrame,
        children: [{
            path: '/index',
            component: Index,
            meta: {
                title: "首页"
            }
        }, {
            path: '/intro',
            component: CenterIntroduce
        }, {
            path: '/judgment',
            component: JudgmentCase
        }, {
            path: '/mediate',
            component: MediateDisputes
        }, {
            path: '/news',
            component: News
        }, {
            path: '/service',
            component: ProceedingService
        }, {
            path: '/mediator',
            component: MediatorList
        }, {
            path: '/caselist',
            component: CaseList
        }, {
            path: '/caserecord',
            component: CaseRecord
        }, {
            path: '/manager',
            component: Manager
        }, {
            path: '/complaint',
            component: Complaint
        }]
    }]
})
router.afterEach(() => {
    document.title = '管理系统 ';
})
export default router
